import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import rings from '../../../assets/rings.png';
import { getFontSize } from '../../../utils/getFont';

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-family: var(--text-cursive);
  ${getFontSize(5)}
  text-align: center;
  margin: 0 0 5rem;
  color: var(--text);

  span {
    display: block;
    margin: 0.5rem 0;
    font-family: var(--text-subtitle);
    ${getFontSize(1)}
  }

  img {
    max-width: 60px;
    height: auto;
    margin: 0 auto 1rem;
  }
`;

const Bible = () => {
  return (
    <Text>
      <img src={rings} alt="Rings" />
      "De modo que ya no son dos,
      <br />
      sino una sola carne."
      <span>Mt 19,6</span>
    </Text>
  );
};

export default Bible;
